import { RouteConfig } from "vue-router";

export const RExpertHOEmail: RouteConfig = {
  path: "ho_email/:tabTypeId(\\d+)",
  name: "HOEmail",
  component: () =>
    import(
      /* webpackChunkName: "ho-email" */
      "./VHOEmail.vue"
    ),
  meta: {
    label: "HO Email",
    tabName: "ho_email",
  },
};
